export default {"src":"/_next/static/media/login.a5774312.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};